import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Chip
} from '@mui/material';
import { People } from '@mui/icons-material';

const CustomerList = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box textAlign="center" mb={4}>
        <People sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom>
          Customer Directory
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          View and Manage All Customer Information
        </Typography>
        <Chip 
          label="Coming Soon" 
          color="primary" 
          variant="outlined" 
          sx={{ mt: 2 }}
        />
      </Box>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Module Overview
        </Typography>
        <Typography variant="body1" paragraph>
          The Customer Directory will provide a comprehensive view of all customers with advanced filtering, 
          search capabilities, and detailed customer relationship management features.
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
          Key Features:
        </Typography>
        <ul>
          <li>View all customers in a searchable list</li>
          <li>Filter customers by type, status, and preferences</li>
          <li>View detailed customer profiles and history</li>
          <li>Track customer interactions and communications</li>
          <li>Manage customer preferences and requirements</li>
          <li>Export customer data and reports</li>
          <li>Bulk operations for customer management</li>
          <li>Customer analytics and insights</li>
        </ul>
      </Paper>
    </Container>
  );
};

export default CustomerList; 